import { connect, ConnectedProps } from 'react-redux';
import { progressSelectorFactory } from 'src/common';
import { RootState } from 'src/store';
import { selectClientId } from '../../../common/store/selectors';
import { ApprovedProductsActionTypes, fetchSecurities, selectApprovedSecurities, selectCurrentInvestmentVersionId } from './../../store/common';
import { Constraints } from './components/constraints';
import { ConstraintsActionTypes, constraintsSlice, fetchConstraints, saveConstraints, selectSecurityConstraints } from './store';

const mapStateToProps = (state: RootState) => ({
  clientId: selectClientId(state),
  currentInvestmentVersionId: selectCurrentInvestmentVersionId(state),
  securityConstraints: selectSecurityConstraints(state),
  isLoadingProgress: progressSelectorFactory([ConstraintsActionTypes.FetchInvestmentServiceConstraints])(state),
  securities: selectApprovedSecurities(state),
  securitiesLoadingProgress: progressSelectorFactory([ApprovedProductsActionTypes.FetchApprovedProducts])(state),
  savingProgress: progressSelectorFactory([ConstraintsActionTypes.UpdateInvestmentServiceConstraints])(state),
});

const mapDispatchToProps = {
  ...constraintsSlice.actions,
  fetchConstraints,
  fetchSecurities,
  saveConstraints,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type Props = ConnectedProps<typeof connector>;
export const ConstraintsContainer = connector(Constraints);
